import { initializeApp } from 'firebase/app';
import {
    getAuth,
    setPersistence,
    browserLocalPersistence
} from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getFunctions } from "firebase/functions";
import { getAnalytics } from 'firebase/analytics';

// Your NEW web app's Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyBXH9iaH5PznrdXYv38c_hualUOb5WIfOU",
    authDomain: "mrjoel-tpt-app.firebaseapp.com",
    projectId: "mrjoel-tpt-app",
    storageBucket: "mrjoel-tpt-app.firebasestorage.app",
    messagingSenderId: "683352120947",
    appId: "1:683352120947:web:fff72564e828bac382d406",
    measurementId: "G-RTC8SLX597"
};

// Initialize Firebase
let app;
let auth;
let db;
let functionsInstance;
let analytics;

try {
    app = initializeApp(firebaseConfig);
    auth = getAuth(app);
    db = getFirestore(app);
    functionsInstance = getFunctions(app);
    analytics = getAnalytics(app);
    setPersistence(auth, browserLocalPersistence);

    // The emulator connection code that was here has been removed.

} catch (error) {
    console.error("Error initializing Firebase:", error);
}

export { app, auth, db, functionsInstance, analytics };